import axios from "axios";
import { getCookie } from "../../getcookie.js";

const apiUrl = process.env.REACT_APP_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
  Authorization: getCookie("mawalog"),
};

export const getAssignmentDetailsApi = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}vehicle_assignment/view/${id}`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching assignment details:", err);
    return err.response;
  }
};

export const updateAssignmentStatusApi = async (id, data) => {
  try {
    const response = await axios.put(`${apiUrl}vehicle_assignment/statusupdate/${id}`, data, { headers: header });
    return response;
  } catch (err) {
    console.error("Error updating assignment status:", err);
    return err.response;
  }
};

export const getVehicleDetailApi = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}get_vehicle_details/${id}`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching vehicle details:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getVehicleAssignmentEditApi = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}vehicle_assignment/edit/${id}`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching assignment edit details:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const createAssignmentApi = async (body) => {
  try {
    const response = await axios.post(`${apiUrl}vehicle_assignment`, body, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error creating assignment:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateAssignmentApi = async (body, id) => {
  try {
    const response = await axios.put(`${apiUrl}vehicle_assignment/${id}`, body, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error updating assignment:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
